import { RemoteDiagnosticsGetVddListByComChannelGeneric } from '../remote-diagnostics.model';
import { LogicalLinkVddList } from './mockedVddList.model';
export class LL_0024_EMCU_CAN71 implements LogicalLinkVddList {
  vddList(): RemoteDiagnosticsGetVddListByComChannelGeneric {
    return {
      service: 'DS_ReadDataByIdent',
      ecu: 'LL_0024_EMCU_CAN71',
      type: 'ListOfVDDsByBaseVariant',
      structure: [
        {
          semantic: '',
          path: 'PA_DataIdent',
          unit: '',
          translationid: '',
          dopname: '2 Byte Text Table VDD-Greenbook',
          name: 'PA_DataIdent',
          value: 'BusIdentification',
          structure: [
            {
              TI_texttableentry: 'TI_BusIdentification',
              isRead: 'true',
              interval: '256',
              texttableentry: 'BusIdentification',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_StatusDtcList',
              isRead: 'true',
              interval: '257',
              texttableentry: 'StatusDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_StatusDtcHistory',
              isRead: 'true',
              interval: '258',
              texttableentry: 'StatusDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InfoDtcList',
              isRead: 'true',
              interval: '259',
              texttableentry: 'InfoDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InfoDtcHistory',
              isRead: 'true',
              interval: '260',
              texttableentry: 'InfoDtcHistory',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ServiceDtcList',
              isRead: 'true',
              interval: '261',
              texttableentry: 'ServiceDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ServiceDtcHistory',
              isRead: 'true',
              interval: '262',
              texttableentry: 'ServiceDtcHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_WarningDtcList',
              isRead: 'true',
              interval: '263',
              texttableentry: 'WarningDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_WarningDtcHistory',
              isRead: 'true',
              interval: '264',
              texttableentry: 'WarningDtcHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ErrorDtcList',
              isRead: 'true',
              interval: '265',
              texttableentry: 'ErrorDtcList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ErrorDtcHistory',
              isRead: 'true',
              interval: '266',
              texttableentry: 'ErrorDtcHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ViessmannIdentificationNumber',
              isRead: 'true',
              interval: '377',
              texttableentry: 'ViessmannIdentificationNumber',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PointOfCommonCouplingPhaseOne',
              isRead: 'true',
              interval: '378',
              texttableentry: 'PointOfCommonCouplingPhaseOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PointOfCommonCouplingPhaseTwo',
              isRead: 'true',
              interval: '379',
              texttableentry: 'PointOfCommonCouplingPhaseTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PointOfCommonCouplingPhaseThree',
              isRead: 'true',
              interval: '380',
              texttableentry: 'PointOfCommonCouplingPhaseThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_UnitsAndFormats',
              isRead: 'true',
              interval: '382',
              texttableentry: 'UnitsAndFormats',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyMatrix',
              isRead: 'true',
              interval: '449',
              texttableentry: 'ElectricalEnergyMatrix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalAlternatingCurrentPowerSetpoint',
              isRead: 'true',
              interval: '451',
              texttableentry: 'ExternalAlternatingCurrentPowerSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_Date',
              isRead: 'true',
              interval: '505',
              texttableentry: 'Date',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_Time',
              isRead: 'true',
              interval: '506',
              texttableentry: 'Time',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_UniversalTimeCoordinated',
              isRead: 'true',
              interval: '507',
              texttableentry: 'UniversalTimeCoordinated',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_UniversalTimeCoordinatedOffset',
              isRead: 'true',
              interval: '508',
              texttableentry: 'UniversalTimeCoordinatedOffset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_Language',
              isRead: 'true',
              interval: '510',
              texttableentry: 'Language',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ObjectElectricalEnergyStatistical',
              isRead: 'true',
              interval: '535',
              texttableentry: 'ObjectElectricalEnergyStatistical',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ResetSensorMinMaxAverageStatistics',
              isRead: 'true',
              interval: '569',
              texttableentry: 'ResetSensorMinMaxAverageStatistics',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetStatistics',
              isRead: 'true',
              interval: '570',
              texttableentry: 'ResetStatistics',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDefaultValues',
              isRead: 'false',
              interval: '571',
              texttableentry: 'SetDefaultValues',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDefaultValuesDate',
              isRead: 'true',
              interval: '572',
              texttableentry: 'SetDefaultValuesDate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RemoteReset',
              isRead: 'true',
              interval: '573',
              texttableentry: 'RemoteReset',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_RemoteResetCounter',
              isRead: 'true',
              interval: '574',
              texttableentry: 'RemoteResetCounter',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SetDeliveryStatus',
              isRead: 'false',
              interval: '575',
              texttableentry: 'SetDeliveryStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SetDeliveryStatusDate',
              isRead: 'true',
              interval: '576',
              texttableentry: 'SetDeliveryStatusDate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeliveryStatusActive',
              isRead: 'true',
              interval: '577',
              texttableentry: 'DeliveryStatusActive',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SoftwareVersion',
              isRead: 'true',
              interval: '580',
              texttableentry: 'SoftwareVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_HardwareVersion',
              isRead: 'true',
              interval: '581',
              texttableentry: 'HardwareVersion',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PowerOnCounter',
              isRead: 'true',
              interval: '582',
              texttableentry: 'PowerOnCounter',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitOperationHours',
              isRead: 'true',
              interval: '590',
              texttableentry: 'ElectronicControlUnitOperationHours',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MacAdressLan',
              isRead: 'true',
              interval: '592',
              texttableentry: 'MacAddressLan',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayMac',
              isRead: 'true',
              interval: '593',
              texttableentry: 'GatewayMac',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteLocalNetworkStatus',
              isRead: 'true',
              interval: '602',
              texttableentry: 'GatewayRemoteLocalNetworkStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayApEnable',
              isRead: 'true',
              interval: '603',
              texttableentry: 'GatewayApEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayApDataSet',
              isRead: 'true',
              interval: '604',
              texttableentry: 'GatewayApDataSet',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteIp',
              isRead: 'true',
              interval: '607',
              texttableentry: 'GatewayRemoteIp',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProxyServer',
              isRead: 'true',
              interval: '609',
              texttableentry: 'ProxyServer',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProxyPort',
              isRead: 'true',
              interval: '610',
              texttableentry: 'ProxyPort',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProxyUser',
              isRead: 'true',
              interval: '611',
              texttableentry: 'ProxyUser',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProxyPassword',
              isRead: 'false',
              interval: '612',
              texttableentry: 'ProxyPassword',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProxyEnabled',
              isRead: 'true',
              interval: '613',
              texttableentry: 'ProxyEnabled',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteEnable',
              isRead: 'true',
              interval: '616',
              texttableentry: 'GatewayRemoteEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteSsid',
              isRead: 'false',
              interval: '617',
              texttableentry: 'GatewayRemoteSsid',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteIpStatic',
              isRead: 'true',
              interval: '618',
              texttableentry: 'GatewayRemoteIpStatic',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteScanNetwork',
              isRead: 'true',
              interval: '619',
              texttableentry: 'GatewayRemoteScanNetwork',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ServiceEngineer',
              isRead: 'true',
              interval: '623',
              texttableentry: 'ServiceEngineer',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TechnicalSupport',
              isRead: 'true',
              interval: '624',
              texttableentry: 'TechnicalSupport',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyMeter',
              isRead: 'true',
              interval: '680',
              texttableentry: 'EnergyMeter',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteSignalStrength',
              isRead: 'true',
              interval: '900',
              texttableentry: 'GatewayRemoteSignalStrength',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MalfunctionIdenification',
              isRead: 'true',
              interval: '902',
              texttableentry: 'MalfunctionIdentification',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DisplaySettings',
              isRead: 'true',
              interval: '903',
              texttableentry: 'DisplaySettings',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DaylightSavingTimeActive',
              isRead: 'true',
              interval: '912',
              texttableentry: 'DaylightSavingTimeActive',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PersistentMemoryCecksum',
              isRead: 'true',
              interval: '913',
              texttableentry: 'PersistentMemoryCecksum',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TradeFairMode',
              isRead: 'true',
              interval: '918',
              texttableentry: 'TradeFairMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ExternalAccessInProgress',
              isRead: 'true',
              interval: '921',
              texttableentry: 'ExternalAccessInProgress',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProductionTraceabilityByte',
              isRead: 'true',
              interval: '922',
              texttableentry: 'ProductionTraceabilityByte',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_StartUpWizard',
              isRead: 'true',
              interval: '924',
              texttableentry: 'StartUpWizard',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicTraceabilityNumber',
              isRead: 'true',
              interval: '928',
              texttableentry: 'ElectronicTraceabilityNumber',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrix',
              isRead: 'true',
              interval: '954',
              texttableentry: 'BusTopologyMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SecurityAlgorithmNumber',
              isRead: 'true',
              interval: '961',
              texttableentry: 'SecurityAlgorithmNumber',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BootLoaderVersion',
              isRead: 'true',
              interval: '962',
              texttableentry: 'BootLoaderVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ActiveDiagnosticSession',
              isRead: 'true',
              interval: '964',
              texttableentry: 'ActiveDiagnosticSession',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FreezeFrame',
              isRead: 'true',
              interval: '1081',
              texttableentry: 'FreezeFrame',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ParameterIdentificationVersion',
              isRead: 'true',
              interval: '1131',
              texttableentry: 'ParameterIdentificationVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ViessmannIdentificationNumberListInternal',
              isRead: 'true',
              interval: '1132',
              texttableentry: 'ViessmannIdentificationNumberListInternal',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AccentLedBar',
              isRead: 'true',
              interval: '1138',
              texttableentry: 'AccentLedBar',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BackendConnectionStatus',
              isRead: 'true',
              interval: '1165',
              texttableentry: 'BackendConnectionStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ResetDtcHistory',
              isRead: 'true',
              interval: '1166',
              texttableentry: 'ResetDtcHistory',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeInfoAlarmMessage',
              isRead: 'true',
              interval: '1175',
              texttableentry: 'AcknowledgeInfoAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeWarningAlarmMessage',
              isRead: 'true',
              interval: '1176',
              texttableentry: 'AcknowledgeWarningAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeServiceAlarmMessage',
              isRead: 'true',
              interval: '1177',
              texttableentry: 'AcknowledgeServiceAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AcknowledgeErrorAlarmMessage',
              isRead: 'true',
              interval: '1178',
              texttableentry: 'AcknowledgeErrorAlarmMessage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PersistentStorageSupplier',
              isRead: 'true',
              interval: '1184',
              texttableentry: 'PersistentStorageSupplier',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleOneTwo',
              isRead: 'true',
              interval: '1233',
              texttableentry: 'GatewayRemoteVisibleOneTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleThreeFour',
              isRead: 'true',
              interval: '1234',
              texttableentry: 'GatewayRemoteVisibleThreeFour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleFiveSix',
              isRead: 'true',
              interval: '1235',
              texttableentry: 'GatewayRemoteVisibleFiveSix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleSevenEight',
              isRead: 'true',
              interval: '1236',
              texttableentry: 'GatewayRemoteVisibleSevenEight',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_GatewayRemoteVisibleNineTen',
              isRead: 'true',
              interval: '1237',
              texttableentry: 'GatewayRemoteVisibleNineTen',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixTwo',
              isRead: 'true',
              interval: '1286',
              texttableentry: 'BusTopologyMatrixTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixThree',
              isRead: 'true',
              interval: '1287',
              texttableentry: 'BusTopologyMatrixThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixFour',
              isRead: 'true',
              interval: '1288',
              texttableentry: 'BusTopologyMatrixFour',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyMatrixFive',
              isRead: 'true',
              interval: '1289',
              texttableentry: 'BusTopologyMatrixFive',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalInputOneValue',
              isRead: 'true',
              interval: '1452',
              texttableentry: 'DeviceDigitalInputOneValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputOneValue',
              isRead: 'true',
              interval: '1456',
              texttableentry: 'DeviceDigitalOutputOneValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceDigitalOutputTwoValue',
              isRead: 'true',
              interval: '1457',
              texttableentry: 'DeviceDigitalOutputTwoValue',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AnalogAdcInputValues',
              isRead: 'true',
              interval: '1466',
              texttableentry: 'AnalogAdcInputValues',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SafetyRelevantRemoteUnlock',
              isRead: 'true',
              interval: '1467',
              texttableentry: 'SafetyRelevantRemoteUnlock',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_OemProductVersion',
              isRead: 'true',
              interval: '1494',
              texttableentry: 'OemProductVersion',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_DeviceAnalogInputOneValue',
              isRead: 'true',
              interval: '1497',
              texttableentry: 'DeviceAnalogInputOneValue',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_TimeSettingSource',
              isRead: 'true',
              interval: '1504',
              texttableentry: 'TimeSettingSource',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_LastResetCause',
              isRead: 'true',
              interval: '1527',
              texttableentry: 'LastResetCause',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InstallationWizardInProgress',
              isRead: 'true',
              interval: '1533',
              texttableentry: 'InstallationWizardInProgress',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigbeeEnable',
              isRead: 'true',
              interval: '1538',
              texttableentry: 'ZigbeeEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ZigbeeStatus',
              isRead: 'true',
              interval: '1539',
              texttableentry: 'ZigbeeStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ZigbeeIdentification',
              isRead: 'true',
              interval: '1540',
              texttableentry: 'ZigbeeIdentification',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InternalComponentUsage',
              isRead: 'true',
              interval: '1548',
              texttableentry: 'InternalComponentUsage',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageOperationState',
              isRead: 'true',
              interval: '1552',
              texttableentry: 'ElectricalEnergyStorageOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitOdxVersion',
              isRead: 'true',
              interval: '1553',
              texttableentry: 'ElectronicControlUnitOdxVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleOneOperatingData',
              isRead: 'true',
              interval: '1577',
              texttableentry: 'ElectricalEnergyStorageModuleOneOperatingData',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleTwoOperatingData',
              isRead: 'true',
              interval: '1578',
              texttableentry: 'ElectricalEnergyStorageModuleTwoOperatingData',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleThreeOperatingData',
              isRead: 'true',
              interval: '1579',
              texttableentry: 'ElectricalEnergyStorageModuleThreeOperatingData',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleFourOperatingData',
              isRead: 'true',
              interval: '1580',
              texttableentry: 'ElectricalEnergyStorageModuleFourOperatingData',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleFiveOperatingData',
              isRead: 'true',
              interval: '1581',
              texttableentry: 'ElectricalEnergyStorageModuleFiveOperatingData',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleSixOperatingData',
              isRead: 'true',
              interval: '1582',
              texttableentry: 'ElectricalEnergyStorageModuleSixOperatingData',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ExternalAlternatingCurrentPowerSetpointMetaData',
              isRead: 'true',
              interval: '1587',
              texttableentry: 'ExternalAlternatingCurrentPowerSetpointMetaData',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AlternatingCurrentPowerSetpoint',
              isRead: 'true',
              interval: '1588',
              texttableentry: 'AlternatingCurrentPowerSetpoint',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_AlternatingCurrentPowerSetpointMetaData',
              isRead: 'true',
              interval: '1589',
              texttableentry: 'AlternatingCurrentPowerSetpointMetaData',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemOperationState',
              isRead: 'true',
              interval: '1590',
              texttableentry: 'ElectricalEnergySystemOperationState',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyInverterOperationState',
              isRead: 'true',
              interval: '1591',
              texttableentry: 'ElectricalEnergyInverterOperationState',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyInverterPath',
              isRead: 'true',
              interval: '1592',
              texttableentry: 'ElectricalEnergyInverterPath',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PointOfCommonCouplingPower',
              isRead: 'true',
              interval: '1603',
              texttableentry: 'PointOfCommonCouplingPower',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MalfunctionUnitBlocked',
              isRead: 'true',
              interval: '1607',
              texttableentry: 'MalfunctionUnitBlocked',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SupportedFeatures',
              isRead: 'true',
              interval: '1660',
              texttableentry: 'SupportedFeatures',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageStateOfCharge',
              isRead: 'true',
              interval: '1664',
              texttableentry: 'ElectricalEnergyStorageStateOfCharge',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AmbientTemperatureSensor',
              isRead: 'true',
              interval: '1684',
              texttableentry: 'AmbientTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyInverterDCConfiguration',
              isRead: 'true',
              interval: '1685',
              texttableentry: 'ElectricalEnergyInverterDCConfiguration',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemPhotovoltaicLimitation',
              isRead: 'true',
              interval: '1686',
              texttableentry: 'ElectricalEnergySystemPhotovoltaicLimitation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemPhotovoltaicConfiguration',
              isRead: 'true',
              interval: '1687',
              texttableentry: 'ElectricalEnergySystemPhotovoltaicConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemPhotovoltaicStatus',
              isRead: 'true',
              interval: '1690',
              texttableentry: 'ElectricalEnergySystemPhotovoltaicStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_BusTopologyScanStatus',
              isRead: 'true',
              interval: '1691',
              texttableentry: 'BusTopologyScanStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PowerGridCodeConfiguration',
              isRead: 'true',
              interval: '1692',
              texttableentry: 'PowerGridCodeConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GridOperatorConfigurationLock',
              isRead: 'true',
              interval: '1693',
              texttableentry: 'GridOperatorConfigurationLock',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayEthernetEnable',
              isRead: 'true',
              interval: '1694',
              texttableentry: 'GatewayEthernetEnable',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayEthernetConfig',
              isRead: 'true',
              interval: '1695',
              texttableentry: 'GatewayEthernetConfig',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayEthernetIp',
              isRead: 'true',
              interval: '1696',
              texttableentry: 'GatewayEthernetIp',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_GatewayEthernetNetworkStatus',
              isRead: 'true',
              interval: '1697',
              texttableentry: 'GatewayEthernetNetworkStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SupportedFeaturesTelemetryControlUnit',
              isRead: 'true',
              interval: '1698',
              texttableentry: 'SupportedFeaturesTelemetryControlUnit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ActivatedFeaturesTelemetryControlUnit',
              isRead: 'true',
              interval: '1699',
              texttableentry: 'ActivatedFeaturesTelemetryControlUnit',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EebusDeviceList',
              isRead: 'true',
              interval: '1700',
              texttableentry: 'EebusDeviceList',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_EebusOwnInfo',
              isRead: 'true',
              interval: '1701',
              texttableentry: 'EebusOwnInfo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EebusPartnerInfo',
              isRead: 'true',
              interval: '1702',
              texttableentry: 'EebusPartnerInfo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EebusConnectionStatus',
              isRead: 'true',
              interval: '1703',
              texttableentry: 'EebusConnectionStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_FunctionalSoftwareVersion',
              isRead: 'true',
              interval: '1710',
              texttableentry: 'FunctionalSoftwareVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergySystemConfiguration',
              isRead: 'true',
              interval: '1718',
              texttableentry: 'ElectricalEnergySystemConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageEnergyTransferStatistic',
              isRead: 'true',
              interval: '1801',
              texttableentry: 'ElectricalEnergyStorageEnergyTransferStatistic',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EnergyProductionPhotovoltaic',
              isRead: 'true',
              interval: '1802',
              texttableentry: 'EnergyProductionPhotovoltaic',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyInverterDcInputOne',
              isRead: 'true',
              interval: '1807',
              texttableentry: 'ElectricalEnergyInverterDcInputOne',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyInverterDcInputTwo',
              isRead: 'true',
              interval: '1808',
              texttableentry: 'ElectricalEnergyInverterDcInputTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyInverterDcInputThree',
              isRead: 'true',
              interval: '1809',
              texttableentry: 'ElectricalEnergyInverterDcInputThree',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyInverterPowerAc',
              isRead: 'true',
              interval: '1810',
              texttableentry: 'ElectricalEnergyInverterPowerAc',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleSetUpCheck',
              isRead: 'true',
              interval: '1811',
              texttableentry: 'ElectricalEnergyStorageModuleSetUpCheck',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PointOfCommonCouplingConfiguredEnergyMeter',
              isRead: 'true',
              interval: '1812',
              texttableentry: 'PointOfCommonCouplingConfiguredEnergyMeter',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThreePhaseInverterCurrent',
              isRead: 'true',
              interval: '1822',
              texttableentry: 'ThreePhaseInverterCurrent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThreePhaseInverterVoltage',
              isRead: 'true',
              interval: '1823',
              texttableentry: 'ThreePhaseInverterVoltage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThreePhaseInverterCurrentPower',
              isRead: 'true',
              interval: '1824',
              texttableentry: 'ThreePhaseInverterCurrentPower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThreePhaseInverterCurrentApparentPower',
              isRead: 'true',
              interval: '1825',
              texttableentry: 'ThreePhaseInverterCurrentApparentPower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ThreePhaseInverterMaximunNominalPower',
              isRead: 'true',
              interval: '1826',
              texttableentry: 'ThreePhaseInverterMaximunNominalPower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InverterElectricalEnergyStorageMaximumNominalChargePower',
              isRead: 'true',
              interval: '1827',
              texttableentry: 'InverterElectricalEnergyStorageMaximumNominalChargePower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InverterElectricalEnergyStorageCurrentMaximumlChargePower',
              isRead: 'true',
              interval: '1828',
              texttableentry: 'InverterElectricalEnergyStorageCurrentMaximumlChargePower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InverterElectricalEnergyStorageMaximumNominalDischargePower',
              isRead: 'true',
              interval: '1829',
              texttableentry: 'InverterElectricalEnergyStorageMaximumNominalDischargePower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InverterElectricalEnergyStorageCurrentMaximumlDishargePower',
              isRead: 'true',
              interval: '1830',
              texttableentry: 'InverterElectricalEnergyStorageCurrentMaximumlDishargePower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PhotovoltaicCurrentStringPower',
              isRead: 'true',
              interval: '1831',
              texttableentry: 'PhotovoltaicCurrentStringPower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PhotovoltaicStringCurrent',
              isRead: 'true',
              interval: '1832',
              texttableentry: 'PhotovoltaicStringCurrent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PhotovoltaicStringVoltage',
              isRead: 'true',
              interval: '1833',
              texttableentry: 'PhotovoltaicStringVoltage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageStateOfEnergy',
              isRead: 'true',
              interval: '1834',
              texttableentry: 'ElectricalEnergyStorageStateOfEnergy',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ManufacturerProperties',
              isRead: 'true',
              interval: '1835',
              texttableentry: 'ManufacturerProperties',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageCurrentPower',
              isRead: 'true',
              interval: '1836',
              texttableentry: 'ElectricalEnergyStorageCurrentPower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageCurrent',
              isRead: 'true',
              interval: '1837',
              texttableentry: 'ElectricalEnergyStorageCurrent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageVoltage',
              isRead: 'true',
              interval: '1838',
              texttableentry: 'ElectricalEnergyStorageVoltage',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageUsableEnergy',
              isRead: 'true',
              interval: '1839',
              texttableentry: 'ElectricalEnergyStorageUsableEnergy',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageUsableNominalEnergy',
              isRead: 'true',
              interval: '1840',
              texttableentry: 'ElectricalEnergyStorageUsableNominalEnergy',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PointOfCommonCouplingOverview',
              isRead: 'true',
              interval: '1841',
              texttableentry: 'PointOfCommonCouplingOverview',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PointOfCommonCouplingAcActiveCurrent',
              isRead: 'true',
              interval: '2144',
              texttableentry: 'PointOfCommonCouplingAcActiveCurrent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BackupBoxTest',
              isRead: 'true',
              interval: '2184',
              texttableentry: 'BackupBoxTest',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PointOfCommonCouplingSetActivePowerTotal',
              isRead: 'true',
              interval: '2188',
              texttableentry: 'PointOfCommonCouplingSetActivePowerTotal',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EebusDeviceListTwo',
              isRead: 'true',
              interval: '2189',
              texttableentry: 'EebusDeviceListTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EebusDeviceListThree',
              isRead: 'true',
              interval: '2190',
              texttableentry: 'EebusDeviceListThree',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EebusDeviceListFour',
              isRead: 'true',
              interval: '2191',
              texttableentry: 'EebusDeviceListFour',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_EebusDeviceListFive',
              isRead: 'true',
              interval: '2192',
              texttableentry: 'EebusDeviceListFive',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BackupBoxConfiguration',
              isRead: 'true',
              interval: '2214',
              texttableentry: 'BackupBoxConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InputDemandSideManagementlReceiver',
              isRead: 'true',
              interval: '2217',
              texttableentry: 'InputDemandSideManagementlReceiver',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_RemoteLimitValueDemandSideManagement',
              isRead: 'true',
              interval: '2218',
              texttableentry: 'RemoteLimitValueDemandSideManagement',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BatteryCalibration',
              isRead: 'true',
              interval: '2219',
              texttableentry: 'BatteryCalibration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BatteryReactivePowerMode',
              isRead: 'true',
              interval: '2220',
              texttableentry: 'BatteryReactivePowerMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BatteryReactivePowerFixCosinusPhi',
              isRead: 'true',
              interval: '2221',
              texttableentry: 'BatteryReactivePowerFixCosinusPhi',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BatteryReactivePower',
              isRead: 'true',
              interval: '2222',
              texttableentry: 'BatteryReactivePower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BatteryReactivePowerCosinusPhi',
              isRead: 'true',
              interval: '2223',
              texttableentry: 'BatteryReactivePowerCosinusPhi',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PhotovoltaicsActivePowerLimitation',
              isRead: 'true',
              interval: '2224',
              texttableentry: 'PhotovoltaicsActivePowerLimitation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricEnergyStorageSetpoint',
              isRead: 'true',
              interval: '2225',
              texttableentry: 'ElectricEnergyStorageSetpoint',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricEnergyStorageMaximum',
              isRead: 'true',
              interval: '2226',
              texttableentry: 'ElectricEnergyStorageMaximum',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PowerGridCodeSettingsNormOne',
              isRead: 'true',
              interval: '2234',
              texttableentry: 'PowerGridCodeSettingsNormOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_CascadeSystemConfiguration',
              isRead: 'true',
              interval: '2235',
              texttableentry: 'CascadeSystemConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricEnergyStorageControlMode',
              isRead: 'true',
              interval: '2239',
              texttableentry: 'ElectricEnergyStorageControlMode',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BatteryTemperatureSensor',
              isRead: 'true',
              interval: '2240',
              texttableentry: 'BatteryTemperatureSensor',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PowerGridCodeSettingsNormTwo',
              isRead: 'true',
              interval: '2242',
              texttableentry: 'PowerGridCodeSettingsNormTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PowerGridCodeSettingsNormThree',
              isRead: 'true',
              interval: '2243',
              texttableentry: 'PowerGridCodeSettingsNormThree',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PowerGridCodeSettingsNormFour',
              isRead: 'true',
              interval: '2244',
              texttableentry: 'PowerGridCodeSettingsNormFour',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PowerGridCodeSettingsNormFive',
              isRead: 'true',
              interval: '2245',
              texttableentry: 'PowerGridCodeSettingsNormFive',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_FixReactivePowerIn',
              isRead: 'true',
              interval: '2246',
              texttableentry: 'FixReactivePowerIn',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PowerGridCodeSettingConfiguration',
              isRead: 'true',
              interval: '2254',
              texttableentry: 'PowerGridCodeSettingConfiguration',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BatteryEnergyUsedAverage',
              isRead: 'true',
              interval: '2329',
              texttableentry: 'BatteryEnergyUsedAverage',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PhotovoltaicsActivePowerLimitationEnergyManagementSystem',
              isRead: 'true',
              interval: '2348',
              texttableentry: 'PhotovoltaicsActivePowerLimitationEnergyManagementSystem',
              isWrite: 'true',
            },
            {
              TI_texttableentry:
                'TI_PhotovoltaicsActivePowerLimitationFallbackEnergyManagementSystem',
              isRead: 'true',
              interval: '2349',
              texttableentry: 'PhotovoltaicsActivePowerLimitationFallbackEnergyManagementSystem',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PowerGridCodeSettingsNormSix',
              isRead: 'true',
              interval: '2533',
              texttableentry: 'PowerGridCodeSettingsNormSix',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_AlternatingCurrentEnergyStatistic',
              isRead: 'true',
              interval: '2539',
              texttableentry: 'AlternatingCurrentEnergyStatistic',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProductMatrix',
              isRead: 'true',
              interval: '2593',
              texttableentry: 'ProductMatrix',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_SetDeliveryStateExpert',
              isRead: 'true',
              interval: '2610',
              texttableentry: 'SetDeliveryStateExpert',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SupportedCountryCodes',
              isRead: 'true',
              interval: '2638',
              texttableentry: 'SupportedCountryCodes',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_MaximumRechargePower',
              isRead: 'true',
              interval: '2643',
              texttableentry: 'MaximumRechargePower',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProductMatrixTwo',
              isRead: 'true',
              interval: '2776',
              texttableentry: 'ProductMatrixTwo',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PrimaryBootLoaderVersion',
              isRead: 'true',
              interval: '2777',
              texttableentry: 'PrimaryBootLoaderVersion',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_InverterSelfTestStatus',
              isRead: 'true',
              interval: '2802',
              texttableentry: 'InverterSelfTestStatus',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InverterSelfTestResultOne',
              isRead: 'true',
              interval: '2803',
              texttableentry: 'InverterSelfTestResultOne',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InverterSelfTestResultTwo',
              isRead: 'true',
              interval: '2804',
              texttableentry: 'InverterSelfTestResultTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_InverterSelfTestResultThree',
              isRead: 'true',
              interval: '2805',
              texttableentry: 'InverterSelfTestResultThree',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ProductIdentification',
              isRead: 'true',
              interval: '2829',
              texttableentry: 'ProductIdentification',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_PowerGridCodeSettingsNormSeven',
              isRead: 'true',
              interval: '2849',
              texttableentry: 'PowerGridCodeSettingsNormSeven',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageSystemState',
              isRead: 'true',
              interval: '2936',
              texttableentry: 'ElectricalEnergyStorageSystemState',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ListOfLayerSettingServiceDevices',
              isRead: 'true',
              interval: '2942',
              texttableentry: 'ListOfLayerSettingServiceDevices',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ResetSystemDeviceList',
              isRead: 'true',
              interval: '2943',
              texttableentry: 'ResetSystemDeviceList',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_NodeIdOnExternalCan',
              isRead: 'true',
              interval: '2944',
              texttableentry: 'NodeIdOnExternalCan',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PointOfCommonCouplingEnergyMeterConnectedPhases',
              isRead: 'true',
              interval: '2945',
              texttableentry: 'PointOfCommonCouplingEnergyMeterConnectedPhases',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_SleepModePrevention',
              isRead: 'true',
              interval: '2947',
              texttableentry: 'SleepModePrevention',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ListOfLayerSettingServiceDevicesTwo',
              isRead: 'true',
              interval: '2952',
              texttableentry: 'ListOfLayerSettingServiceDevicesTwo',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_ElectronicControlUnitSafeStateStatus',
              isRead: 'true',
              interval: '2969',
              texttableentry: 'ElectronicControlUnitSafeStateStatus',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleOneInformation',
              isRead: 'true',
              interval: '3085',
              texttableentry: 'ElectricalEnergyStorageModuleOneInformation',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleTwoInformation',
              isRead: 'true',
              interval: '3086',
              texttableentry: 'ElectricalEnergyStorageModuleTwoInformation',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleThreeInformation',
              isRead: 'true',
              interval: '3087',
              texttableentry: 'ElectricalEnergyStorageModuleThreeInformation',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleFourInformation',
              isRead: 'true',
              interval: '3088',
              texttableentry: 'ElectricalEnergyStorageModuleFourInformation',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleFiveInformation',
              isRead: 'true',
              interval: '3089',
              texttableentry: 'ElectricalEnergyStorageModuleFiveInformation',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_ElectricalEnergyStorageModuleSixInformation',
              isRead: 'true',
              interval: '3090',
              texttableentry: 'ElectricalEnergyStorageModuleSixInformation',
              isWrite: 'false',
            },
            {
              TI_texttableentry: 'TI_IslandModeLoadInformation',
              isRead: 'true',
              interval: '3103',
              texttableentry: 'IslandModeLoadInformation',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_BatteryModuleExchangeAssistent',
              isRead: 'true',
              interval: '3107',
              texttableentry: 'BatteryModuleExchangeAssistent',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_PhotovoltaicsActivePowerLimitationRampRate',
              isRead: 'true',
              interval: '3108',
              texttableentry: 'PhotovoltaicsActivePowerLimitationRampRate',
              isWrite: 'true',
            },
            {
              TI_texttableentry: 'TI_TelemetryControlUnitTargetOperationMode',
              isRead: 'true',
              interval: '3188',
              texttableentry: 'TelemetryControlUnitTargetOperationMode',
              isWrite: 'false',
            },
          ],
        },
      ],
    };
  }
}
